export default {
  roles: [],
  role: null,
  permissions: [],
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
